import { SupplierDB_controller } from '../../../Services/DB_Controller/SupplierDB_controller';
import { RawMaterialInfo } from '../../../Services/Object_Classes/RawMaterial/RawMaterial';
import { RawDB_controller } from '../../../Services/DB_Controller/RawDB_controller';
import { RawMaterialOrder } from '../../../Services/Object_Classes/RawMaterial/PORawMaterial';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ThemePalette, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Machine } from 'src/app/Services/Object_Classes/Machine/Machine';
import { Part } from 'src/app/Services/Object_Classes/Part/Part';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { ViewRawMaterialsComponent } from 'src/app/Shared/view-raw-materials/view-raw-materials.component';
import { v4 as uuidv4 } from 'uuid';
import { PORawDB_controller } from 'src/app/Services/DB_Controller/PORawMaterialDB_controller';
import { PurchaseOrderRaw } from 'src/app/Services/Object_Classes/RawMaterial/PORawMaterial';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { Supplier } from 'src/app/Services/Object_Classes/RawMaterial/Supplier';
import { PODB_controller } from 'src/app/Services/DB_Controller/PODB_controller';
import { PartTracker, PurchaseOrder } from 'src/app/Services/Object_Classes/PurchaseOrder/PurchaseOrder';
import { PartDB_controller } from 'src/app/Services/DB_Controller/PartDB_controller';
import { ThirdPartyDraggable } from '@fullcalendar/interaction';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { toHexString } from 'pdf-lib';

@Component({
  selector: 'app-scan-end',
  templateUrl: './scan-end.component.html',
  styleUrls: ['./scan-end.component.css']
})
export class ScanEndComponent implements OnInit {
  @ViewChild('scrollMe', { static: false }) private myScrollContainer: ElementRef;

  po_controller: PODB_controller = new PODB_controller(this.db);
  PORawController: PORawDB_controller = new PORawDB_controller(this.db, this.firestore);

  soList: any = [];
  partList: any = [];
  endDateList: any = [];
  oldStatusList: any = [];
  outsourcelist: RawMaterialInfo[] = [];
  RawListTDO: RawMaterialOrder[] = [];
  matOutsourcesRaw: any = [];
  matSelectPO: PartTracker[] = [];
  cloneSelectPO: PartTracker[] = [];

  addForm: FormGroup;
  isScanned = false;

  email: string;
  scanning: any = '';

  constructor(
    private dialogRef: MatDialogRef<ScanEndComponent>,
    private fb: FormBuilder,
    private toast: ToastrService,
    private db: AngularFireDatabase,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private spinner : NgxSpinnerService,
    private dateFormat: DateFormatService,
    private firestore: AngularFirestore
  ) {
    this.addForm = this.fb.group({
      outsources: this.fb.array([]),
    });

    this.angularFireAuth.authState.subscribe(auth=>{this.email = auth.email;})
  }

  ngOnInit() {
    this.spinner.show();

    this.po_controller.getJOList().then(data => {
      this.matSelectPO = data;
      this.cloneSelectPO = this.matSelectPO.slice();
      this.spinner.hide();
    });

    this.PORawController.search_TDO_Details_withStatusPending().then(data => {
      this.RawListTDO = data;
      this.spinner.hide();
    });
  }

  outsources(): FormArray {
    return this.addForm.get('outsources') as FormArray;
  }

  newOutsourcesBarcode(joNo: any, SO_No: any, partNumber: any, name: any, quant: any, endDate: any): FormGroup {
    const projectFilterControl = new FormControl();
    this.partList.push(partNumber);
    this.endDateList.push(endDate);
    this.soList.push(SO_No);

    projectFilterControl.valueChanges.subscribe(() => {
      this.findJO(projectFilterControl);
    });

    this.scrollToBottom();

    return this.fb.group({
      projectFilterControl,
      project: joNo,
      partName: name,
      soQuantity: quant,
      quantity: quant
    });
  }

  newOutsources(): FormGroup {
    const projectFilterControl = new FormControl();
    
    projectFilterControl.valueChanges.subscribe(() => {
      this.findJO(projectFilterControl);
    });

    this.scrollToBottom();

    return this.fb.group({
      projectFilterControl,
      project: "",
      partName: "",
      soQuantity: 0,
      quantity: 0
    });
  }

  addOutsources() {
    this.outsources().push(this.newOutsources());
    this.outsourcelist.push(null);
  }

  scan(){
    $('#barcode').val('');
    $('#barcode').trigger('focus');
    this.scanning = "Scanning......";
  }

  removeOutsource(i: number) {
    if(!this.isScanned){
      this.outsources().removeAt(i);
      this.outsourcelist.splice(i, 1);
      this.oldStatusList.splice(i, 1);
    }
    else{
      this.isScanned = false;
    }   
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async confirm() {
    const outsources = this.addForm.get('outsources').value;

    if(outsources == null || outsources.length <= 0){
      this.toast.error('Need At Least Start One JO', 'Please Add');
      return;
    }

    const addPOModel = {
      outsources: []
    };
    
    var flag = true;
    await outsources.forEach(async (element, index) => {
      if (!element.project || !element.partName || !element.soQuantity || !element.quantity) {
        this.toast.error('JO information(' + (index + 1) + ') not completed!', 'Please fill in');
        flag=false;
      }

      const info = {
        SO_No: this.soList[index],
        JO_No: element.project,
        PO_Part_No: this.partList[index],
        PO_Part_Name: element.partName,
        SoQuantity: element.soQuantity,
        POQuantity: element.quantity,
        endDate: this.endDateList[index],
        status: element.quantity >= element.soQuantity ? 'Complete' : 'Processing'
      };

      addPOModel.outsources.push(info);
    });

    if(!flag)
      return;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '50%';
    const position = {
      top: '5%'
    };
    
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm to end these JO?';
    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async result => {
      if (result) {
        await addPOModel.outsources.forEach(async (machine, index)=>{
          if(machine.JO_No.includes(machine.SO_No)){
            let updates1 = {};
            var current = new Date().getTime().toString();
            updates1[machine.SO_No + '/Part List/' + machine.JO_No + '/Part Quantity'] = machine.POQuantity;
            updates1[machine.SO_No + '/Part List/' + machine.JO_No + '/Status'] = machine.status;
            updates1[machine.SO_No + '/Part List/' + machine.JO_No + '/Schedule/' + current + '/Process'] = "Completed";
            updates1[machine.SO_No + '/Part List/' + machine.JO_No + '/Schedule/' + current + '/Created_By'] = this.email;
            await this.db.database.ref('Purchase Order/').update(updates1);
  
            if(this.oldStatusList[index] == "Outsourcing"){
              let tdo = this.RawListTDO.find(a => a.JO_No == machine.JO_No);
              var uid = uuidv4();
  
              if(tdo){
                let updates2 = {};
                updates2[tdo.TDOno + '/RawMaterials/' + tdo.PO_Order_ID + '/_Received_Quantity'] = tdo.PO_RawMaterial_Qty;
                updates2[tdo.TDOno + '/RawMaterials/' + tdo.PO_Order_ID + '/_PO_RawMaterial_Status'] = "Completed";
                updates2[tdo.TDOno + '/RawMaterials/' + tdo.PO_Order_ID + '/ReceivedDetails/' + uid + '/_Received_Date'] = new Date().toISOString();
                updates2[tdo.TDOno + '/RawMaterials/' + tdo.PO_Order_ID + '/ReceivedDetails/' + uid + '/_Received_Quantity'] = tdo.PO_RawMaterial_Qty;
                await this.db.database.ref('PO Outsource/').update(updates2);

                if (snapshot.exists()) {
                  var allCompleted = true;
                  this.db.database.ref('PO Outsource/' + tdo.TDOno + '/_Status').set("Completed");
                  this.db.database.ref('PO Outsource/' + tdo.TDOno + '/_Completed_Date').set(new Date().toISOString());
          
                  await snapshot.child("RawMaterials").forEach((childSnapshot) => {
                    if(allCompleted){
                      if(childSnapshot.child("_PO_RawMaterial_Status").val() != 'Completed'){
                        this.db.database.ref('PO Outsource/' + tdo.TDOno + '/_Status').set("Pending");
                        this.db.database.ref('PO Outsource/' + tdo.TDOno + '/_Completed_Date').set(null);
                        allCompleted = false;
                      }
                    }
                  });
          
                  this.db.database.ref('PO Outsource/' + tdo.TDOno + '/_Updated_By').set(this.email);
                }
              }
            }
  
            var snapshot = await this.db.database.ref('Purchase Order').child(machine.SO_No).child('Part List').once('value');
            var breakMe = false;
  
            if (snapshot.exists()) {
              snapshot.forEach((childSnapshot2) =>{
                if(breakMe == false) {
                  if(childSnapshot2.child('Status').val() != 'Complete'){
                    this.db.database.ref('Purchase Order/' + machine.SO_No + '/_Status').set("Incomplete");
                    breakMe = true;
                  }
                  else{
                    this.db.database.ref('Purchase Order/' + machine.SO_No + '/_Status').set("Complete");
                  }
                }
              });
            }
          }
        });

        this.dialogRef.close(true);
      }
    });
  }

  findJO(supplier) {
    if (!this.cloneSelectPO) { return; }
    const search = supplier.value;
    this.matSelectPO = this.cloneSelectPO.filter(p => p.JO_No.toLowerCase().includes(search.toLowerCase()));
  }

  padLeadingZeros(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  async joChange(event, formindex:0){
    let jo = await this.matSelectPO.find(a=>a.JO_No == event.value);

    if(jo && jo.PO_Status != 'Complete'){
      this.partList[formindex] = jo.PO_Part_ID;
      //this.endDateList.push(jo.EndDate);
      this.soList[formindex] = jo.SO_No;
      ((this.addForm.get('outsources') as FormArray).at(formindex) as FormGroup).get('partName').patchValue(jo.PO_Part_No);
      ((this.addForm.get('outsources') as FormArray).at(formindex) as FormGroup).get('soQuantity').patchValue(jo.POQuantity);
      ((this.addForm.get('outsources') as FormArray).at(formindex) as FormGroup).get('quantity').patchValue(jo.POQuantity);
    }
    else{
      this.toast.error('This JO is Completed');
    }
  }

  async barcode(event){
    this.isScanned = true;
    let jo = await this.matSelectPO.find(a=>a.JO_No == event.target.value);

    if(jo && jo.PO_Status != 'Complete'){
      this.outsources().push(this.newOutsourcesBarcode(event.target.value, jo.SO_No, jo.PO_Part_ID, jo.PO_Part_No, jo.POQuantity, jo.EndDate));
      this.outsourcelist.push(null);
      this.oldStatusList.push(jo.PO_Status);
    }
    else{
      this.toast.error('This JO is Completed');
    }
    

    $('#barcode').val('');
    $('#barcode').trigger('focus');
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
  }
}
